export const getPropertyFromVar = <T = unknown>(value: unknown, property: string): T | undefined => {
  if (typeof value === "object" && value !== null && property in value) {
    const typedValue = value as { [property]?: T } & Record<string, unknown>;
    return typedValue[property];
  }
  return undefined;
};
